module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加专区")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tagsList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "专区名称",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sort",
      "label": "排序",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.sort) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cat_type",
      "label": "分类ID",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.cat_type) + "\n\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_show",
      "label": "显示",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_show == '1') ? _c('span', [_vm._v("显示")]) : _vm._e(), _vm._v(" "), (scope.row.is_show == '0') ? _c('span', [_vm._v("不显示")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "添加时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.create_time) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "banner_url",
      "label": "图片地址",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.banner_url), function(item, index) {
          return _c('li', {
            key: index,
            staticClass: "goodspic"
          }, [_c('el-image', {
            staticStyle: {
              "width": "100px",
              "height": "60px"
            },
            attrs: {
              "src": item,
              "mode": "modeWidth"
            }
          })], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑标签",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "专区名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "专区名称"
      },
      model: {
        value: (_vm.form.name),
        callback: function($$v) {
          _vm.$set(_vm.form, "name", $$v)
        },
        expression: "form.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "排序"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "数值越小排名越前"
      },
      model: {
        value: (_vm.form.sort),
        callback: function($$v) {
          _vm.$set(_vm.form, "sort", $$v)
        },
        expression: "form.sort"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "分类ID"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "1钱,2优惠券,3实物"
      },
      model: {
        value: (_vm.form.cat_type),
        callback: function($$v) {
          _vm.$set(_vm.form, "cat_type", $$v)
        },
        expression: "form.cat_type"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "显示"
      }
    }, [
      [_c('el-radio-group', {
        on: {
          "change": _vm.type_change
        },
        model: {
          value: (_vm.form.is_show),
          callback: function($$v) {
            _vm.$set(_vm.form, "is_show", $$v)
          },
          expression: "form.is_show"
        }
      }, [_c('el-radio-button', {
        attrs: {
          "label": "1"
        }
      }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio-button', {
        attrs: {
          "label": "0"
        }
      }, [_vm._v("不显示")])], 1)]
    ], 2), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "*店铺图片"
      }
    }, [_c('div', [_c('div', {
      staticClass: "pics-box"
    }, [_c('ul', {
      staticClass: "goodspic-wrap"
    }, [_c('draggable', {
      staticClass: "components-view",
      attrs: {
        "options": _vm.dragIssuesOptions
      },
      model: {
        value: (_vm.form.banner_url),
        callback: function($$v) {
          _vm.$set(_vm.form, "banner_url", $$v)
        },
        expression: "form.banner_url"
      }
    }, _vm._l((_vm.form.banner_url), function(item, index) {
      return _c('li', {
        key: index,
        staticClass: "goodspic",
        on: {
          "mouseenter": function($event) {
            return _vm.storeImagesEnter0(index)
          },
          "mouseleave": _vm.storeImagesLeave0
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.wximageurl + item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goodspic-mask",
        class: (_vm.storeImagesCurrent == index) ? 'on' : ''
      }, [_c('div', {
        staticClass: "iconfont icon-trash-alt",
        on: {
          "click": function($event) {
            return _vm.removeStoreImages0(index)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "iconfont icon-arrows-alt"
      })])])
    }), 0)], 1), _vm._v(" "), (_vm.form.banner_url.length < 9) ? _c('div', {
      staticClass: "upload-box",
      on: {
        "click": _vm.handleStoreImagesChange0
      }
    }, [_c('i', {
      staticClass: "iconfont icon-camera"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_c('p', [_vm._v("1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）")])])]), _vm._v(" "), _c('imgPicker', {
      attrs: {
        "dialog-visible": _vm.storeImagesDialog,
        "sc-status": _vm.isGetStoreImages,
        "is-most": _vm.multiple
      },
      on: {
        "chooseImg": _vm.pickStoreImages0,
        "closeImgDialog": _vm.closeStoreImagesDialog0
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveTagData
      }
    }, [_vm._v("确定保存")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.cancelData
      }
    }, [_vm._v("取消")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38a7affc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a7affc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/jianguan/goods/category.vue
// module id = 2620
// module chunks = 0